import {Injectable} from '@angular/core';
import {ApModalService} from 'webcommon/core-ui';
import {_Module, PatientDto, SessionRequest_Create} from 'webcommon/shared';
import {ImoPatientFactory} from './ImoPatientFactory';
import {TerminologySearchModalComponent} from './terminology-search-modal/terminology-search-modal.component';

// This is meant to replace the ImoSearchModalService/FncImoModal
@Injectable({
  providedIn: 'root',
})
export class TerminologySearchModalService {
  isSupported = TerminologySearchModalComponent.isSupportedFn();

  constructor(
    private apModalService: ApModalService,
    private imoPatientFactory: ImoPatientFactory,
  ) { }

  openModal$(sessionRequest: SessionRequest_Create) {
    return this.apModalService.showComponentModal$(TerminologySearchModalComponent, {
      panelClass: 'emds-modal-full',
      disableClose: true,
      initialState: {
        sessionRequest,
      },
    });
  }

  // this method is to preserve something similar to ImoSearchModalService for the current calls
  openModal2$(patient: PatientDto | null, searchText: string, multiSelect: boolean, hccOnly: boolean) {
    const session: SessionRequest_Create = {
      InitialSearchText: searchText,
      IsSingleSelect: !multiSelect,
      ModuleId: _Module.ImoProblemSearch,
      IncludeAdditionalCodings: true,
      AllowNonBillableCodes: false,
      HccOnly: hccOnly,
      HideSingleSelectSaveAndCancelButtons: true,
      PRM_UseHccDefaultDisplayUserSetting: true,
    };
    const imoPatient = this.imoPatientFactory.mapFromApi(patient);
    if (imoPatient && imoPatient.hasAge) {
      session.PatientAge = imoPatient.standardizedAge;
    }
    if (imoPatient && imoPatient.hasGender) {
      session.PatientBirthSex = imoPatient.standardizedGender;
    }
    return this.openModal$(session);
  }
}

